import { getLogisticsList, getLogistics } from '@fetch/logistics';

const state = {
  logisticsList: [], // 包裹列表
  formatTraces: [],
  deliveryInformation: {}, //包裹信息
  parcelList: [], // 物流配送信息 for 订单详请
  weekDays: [window.TLang('周日','my'), window.TLang('周一','my'), window.TLang('周二','my'), window.TLang('周三','my'), window.TLang('周四','my'), window.TLang('周五','my'), window.TLang('周六','my')],
};
const getters = {
  getParcelTabs: state =>
    state.logisticsList.map((item, index) => {
      return {
        label: window.TLang('包裹','list') + (index + 1),
        id: index,
        name: index + '',
        expressOrderNo: item.expressOrderNo,
      };
    }),
};
const actions = {
  getLogisticsList({ commit, dispatch }, data) {
    getLogisticsList(data).then(res => {
      commit('setLogisticsList', res);
      // 获取第一个包裹信息渲染页面
      const { list } = res;
      if (!list || !list.length) return;
      const { expressOrderNo } = list[0];
      const { deliveryOrderNo } = data;

      dispatch('getLogistics', { deliveryOrderNo, expressOrderNo });
    });
  },
  getLogisticsListForOrderDetail({ commit }, data) {
    getLogisticsList(data).then(res => {
      // 获取第一个包裹信息渲染页面
      const { list } = res;
      const { deliveryOrderNo } = data;
      if (!list || !list.length) return;
      list.map(item => {
        item.deliveryOrderNo = deliveryOrderNo;
        return item;
      });
      // console.log(list);
      commit('setParcelList', list);
    });
  },
  getLogistics({ commit }, data) {
    getLogistics(data).then(res => {
      const { expressCompany, expressOrderNo, traces } = res;
      const { deliveryOrderNo } = data;
      commit('setDeliveryInformation', res);
      commit('setParcelTracks', res);
      commit('setParcelList', [{
        expressCompany,
        expressOrderNo,
        deliveryOrderNo,
        traces,
      }]);
    });
  },
};
const mutations = {
  setLogisticsList(state, { list }) {
    !list ? (state.logisticsList = []) : (state.logisticsList = list);
  },
  setDeliveryInformation(state, { expressCompany, expressOrderNo, deliveryWayName }) {
    state.deliveryInformation = {
      expressCompany,
      expressOrderNo,
      deliveryWayName,
    };
  },
  setParcelTracks(state, { traces }) {
    // traces = [
    //   {
    //     deliveryDate: '2019-10-12 17:00:59',
    //     content:
    //       '【上海市闵行区万辉公司】 派件中 派件人: 尉言理 电话 15821703659 如有疑问，请联系：18918268772',
    //   },
    //   {
    //     deliveryDate: '2019-10-12 17:02:59',
    //     content:
    //       '【上海市闵行区万辉公司】 派件中 派件人: 尉言理 电话 15821703659 如有疑问，请联系：18918268772',
    //   },
    //   {
    //     deliveryDate: '2019-10-11 17:05:59',
    //     content:
    //       '【上海市闵行区万辉公司】 派件中 派件人: 尉言理 电话 15821703659 如有疑问，请联系：18918268772',
    //   },
    //   {
    //     deliveryDate: '2019-10-11 13:05:59',
    //     content:
    //       '【上海市闵行区万辉公司】 派件中 派件人: 尉言理 电话 15821703659 如有疑问，请联系：18918268772',
    //   },
    //   {
    //     deliveryDate: '2019-10-11 10:05:59',
    //     content:
    //       '【上海市闵行区万辉公司】 派件中 派件人: 尉言理 电话 15821703659 如有疑问，请联系：18918268772',
    //   },
    //   {
    //     deliveryDate: '2019-10-10 10:05:59',
    //     content:
    //       '【上海市闵行区万辉公司】 派件中 派件人: 尉言理 电话 15821703659 如有疑问，请联系：18918268772',
    //   }
    // ];
    let signDate = '',
      spaceFlag = true;
    state.formatTraces = traces.map((item, index) => {
      if (!item.deliveryDate) return {};
      const { content } = item;
      let dateArray = item.deliveryDate.split(' ');
      let weekDayIndex = new Date(dateArray[0]).getDay();
      if (index > 0 && signDate !== dateArray[0]) {
        spaceFlag = true;
        signDate = dateArray[0];
      } else {
        if (index) spaceFlag = false;
        signDate = dateArray[0];
      }
      return {
        date: dateArray[0],
        weekDay: state.weekDays[weekDayIndex],
        time: dateArray[1],
        content,
        spaceFlag,
      };
    });
  },
  setParcelList(state, res) {
    state.parcelList = res;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
